import { render, staticRenderFns } from "./MiniCard.vue?vue&type=template&id=5404afc4&scoped=true"
import script from "./MiniCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./MiniCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MiniCard.vue?vue&type=style&index=0&id=5404afc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5404afc4",
  null
  
)

export default component.exports